import { fromJS } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import { byId } from 'store/utils/sortFunctions';
import Outcome from 'models/ImpactPlan/Outcome';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.OUTCOMES_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: action.payload.results
              .reduce(
                (outcomesById, outcome) =>
                  outcomesById.set(String(outcome.id), new Outcome(outcome)),
                state.get('data').get('byId')
              )
              .sort(byId),
          },
        })
      );
    case types.OUTCOME_FETCH_SUCCEEDED:
    case types.OUTCOME_CREATE_SUCCEEDED:
    case types.OUTCOME_UPDATE_SUCCEEDED: {
      return (() =>
        state.merge(
          reduxHelper.applyRequestInfo({
            updatePending: false,
            data: {
              byId: state
                .get('data')
                .get('byId')
                .set(String(action.payload.id), new Outcome(action.payload)),
            },
          })
        ))();
    }
    case types.OUTCOME_FETCH:
    case types.OUTCOME_CREATE:
    case types.OUTCOME_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.OUTCOME_DELETE_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: false,
          data: {
            byId: state.get('data').get('byId').delete(String(action.payload.id)),
          },
        })
      );
    case types.OUTCOME_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.OUTCOME_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.OUTCOME_FETCH_FAILED:
    case types.OUTCOMES_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
